const BASE_FONT_SIZE = 16;
const typography = {
  baseFontSize: BASE_FONT_SIZE,
  mobileFontSize: BASE_FONT_SIZE
};

export type TypographyVariant = keyof typeof typography;
export { typography };
